import { PIPELINE_ADD_STAGE, PIPELINE_ADD_TASK, PIPELINE_ADD_USER_TO_TASK, PIPELINE_CHANGE_TASK_DONE_STATUS, PIPELINE_DELETE_STAGE, PIPELINE_EDIT_PIPELINE, PIPELINE_EDIT_STAGE, PIPELINE_EDIT_TASK, PIPELINE_MOVE_TASK, PIPELINE_REMOVE_ACTIVE_PIPELINE, PIPELINE_REMOVE_USER_FROM_TASK, PIPELINE_REORDER_TASK, PIPELINE_SET_LOADING, PIPELINE_SET_PIPELINE, } from "../constants";
import { convertStageFromServer } from "../utils/stage";
import { convertTaskFromServer, moveTask, reorderTask } from "../utils/task";
const activePipelineReducer = (state, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    switch (action.type) {
        case PIPELINE_SET_LOADING:
            return Object.assign(Object.assign({}, state), { loading: action.payload });
        case PIPELINE_SET_PIPELINE: {
            const pipelineData = action.payload;
            const transformedStages = (pipelineData.stages || []).map((stage) => {
                return Object.assign({}, convertStageFromServer(stage));
            });
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, pipelineData), { stages: transformedStages, is_primary: pipelineData.is_primary === "1" }) });
        }
        case PIPELINE_MOVE_TASK: {
            if (!state.activePipeline || !state.activePipeline.stages) {
                return state;
            }
            const stages = moveTask(state.activePipeline.stages, action.payload.source, action.payload.destination);
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages }) });
        }
        case PIPELINE_REORDER_TASK: {
            const { source, destination } = action.payload;
            const targetStageId = destination.droppableId;
            const targetIndex = destination.index;
            if (!state.activePipeline) {
                return state;
            }
            const targetStage = (_a = state.activePipeline.stages) === null || _a === void 0 ? void 0 : _a.find((stage) => stage.id === targetStageId);
            if (!targetStage || !targetStage.tasks) {
                return state;
            }
            const reorderedTasks = reorderTask(targetStage.tasks, source.index, targetIndex);
            const updatedStages = (_b = state.activePipeline.stages) === null || _b === void 0 ? void 0 : _b.map((stage) => stage.id === targetStageId
                ? Object.assign(Object.assign({}, stage), { tasks: reorderedTasks }) : stage);
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: updatedStages }) });
        }
        case PIPELINE_ADD_TASK: {
            const newTask = convertTaskFromServer(action.payload);
            if (!state.activePipeline) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: (_c = state.activePipeline.stages) === null || _c === void 0 ? void 0 : _c.map((stage) => stage.id === newTask.stage_id
                        ? Object.assign(Object.assign({}, stage), { tasks: [...(stage.tasks || []), newTask] }) : stage) }) });
        }
        case PIPELINE_EDIT_TASK: {
            const editedTask = convertTaskFromServer(action.payload);
            if (!state.activePipeline) {
                return state;
            }
            const updatedStages = (_d = state.activePipeline.stages) === null || _d === void 0 ? void 0 : _d.map((stage) => {
                var _a;
                return stage.id === editedTask.stage_id
                    ? Object.assign(Object.assign({}, stage), { tasks: (_a = stage.tasks) === null || _a === void 0 ? void 0 : _a.map((task) => task.id === editedTask.id ? editedTask : task) }) : stage;
            });
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: updatedStages }) });
        }
        case PIPELINE_ADD_STAGE: {
            const stage = action.payload;
            if (!state.activePipeline) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: [...(state.activePipeline.stages || []), stage] }) });
        }
        case PIPELINE_EDIT_STAGE: {
            const updatedStage = action.payload;
            if (!state.activePipeline) {
                return state;
            }
            const updateStage = (stage) => {
                if (stage.id === updatedStage.id) {
                    return Object.assign(Object.assign({}, stage), { name: updatedStage.name, description: updatedStage.description });
                }
                return stage;
            };
            const updatedStages = (_e = state.activePipeline.stages) === null || _e === void 0 ? void 0 : _e.map(updateStage);
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: updatedStages }) });
        }
        case PIPELINE_DELETE_STAGE: {
            const deletedStageId = action.payload;
            if (!state.activePipeline) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: (_f = state.activePipeline.stages) === null || _f === void 0 ? void 0 : _f.filter((stage) => stage.id !== deletedStageId) }) });
        }
        case PIPELINE_ADD_USER_TO_TASK: {
            const { taskId, user } = action.payload;
            if (!state.activePipeline) {
                return state;
            }
            const updatedStages = (_g = state.activePipeline.stages) === null || _g === void 0 ? void 0 : _g.map((stage) => {
                var _a;
                const updatedTasks = (_a = stage.tasks) === null || _a === void 0 ? void 0 : _a.map((task) => {
                    if (task.id === taskId) {
                        return Object.assign(Object.assign({}, task), { assigned_users: [user, ...(task.assigned_users || [])] });
                    }
                    return task;
                });
                return Object.assign(Object.assign({}, stage), { tasks: updatedTasks });
            });
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: updatedStages }) });
        }
        case PIPELINE_REMOVE_USER_FROM_TASK: {
            const { taskId, userId } = action.payload;
            if (!state.activePipeline) {
                return state;
            }
            const updatedStages = (_h = state.activePipeline.stages) === null || _h === void 0 ? void 0 : _h.map((stage) => {
                var _a;
                const updatedTasks = (_a = stage.tasks) === null || _a === void 0 ? void 0 : _a.map((task) => {
                    var _a;
                    if (task.id === taskId) {
                        return Object.assign(Object.assign({}, task), { assigned_users: (_a = task.assigned_users) === null || _a === void 0 ? void 0 : _a.filter((user) => user.id !== userId) });
                    }
                    return task;
                });
                return Object.assign(Object.assign({}, stage), { tasks: updatedTasks });
            });
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: updatedStages }) });
        }
        case PIPELINE_EDIT_PIPELINE: {
            const updatedPipeline = action.payload;
            if (!state.activePipeline) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { name: updatedPipeline.name, description: updatedPipeline.description, is_primary: updatedPipeline.is_primary === "1" }) });
        }
        case PIPELINE_CHANGE_TASK_DONE_STATUS: {
            const { taskId, done } = action.payload;
            if (!state.activePipeline) {
                return state;
            }
            const updatedStages = (_j = state.activePipeline.stages) === null || _j === void 0 ? void 0 : _j.map((stage) => {
                var _a;
                const updatedTasks = (_a = stage.tasks) === null || _a === void 0 ? void 0 : _a.map((task) => {
                    if (task.id === taskId) {
                        return Object.assign(Object.assign({}, task), { is_done: done });
                    }
                    return task;
                });
                return Object.assign(Object.assign({}, stage), { tasks: updatedTasks });
            });
            return Object.assign(Object.assign({}, state), { activePipeline: Object.assign(Object.assign({}, state.activePipeline), { stages: updatedStages }) });
        }
        case PIPELINE_REMOVE_ACTIVE_PIPELINE: {
            return Object.assign(Object.assign({}, state), { activePipeline: null });
        }
        default:
            return state;
    }
};
export { activePipelineReducer };
